import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import Header from './Header';
import Footer from '../Footer';

const LayoutPage: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <CssBaseline />
      <Header />
      <Box
        sx={{
          marginTop: '64px',
          backgroundColor: 'background.default',
          flex: 1,
          overflow: 'auto',
        }}
      >
        <Outlet />
      </Box>
      <Footer />
    </Box>
    );
}

export default LayoutPage;